<template>
    <el-dialog custom-class="dialogForm" class="measDialog" :visible.sync="visible" :before-close="handleClose" :close-on-click-modal="false" width="80%" :title="title">
        <el-scrollbar class="dialogContentScroll">
            <div class="correctConte">
                <div class="studentInfo flex">
                    <div class="left flex">
                        <!-- <img src="" alt=""> -->
                        <div class="img mr-20">
                            <img :src="infoData.logourl ? infoData.logourl : require('@/common/images/user.png')" alt="">
                        </div>
                        <div>
                            <p class="name">{{infoData.studentname}}</p>
                            <p class="correctName">{{infoData.name}}</p>
                        </div>
                    </div>
                    <div class="center">
                        <p>开始时间：{{infoData.starttime}}</p>
                        <p class="mt-20">交卷时间：{{infoData.submittime}}</p>
                    </div>
                    <div class="right">
                        <p>用时：{{infoData.factexamtime}} 分</p>
                        <p class="mt-20">成绩：{{infoData.examtotalscore}} 分</p>
                    </div>
                    <!-- <div class="left">
                        <span class="label">答题人:</span>
                        <div class="img">
                            <img src="../../../../assets/measAssets/image/common/no_data.png" alt="">
                        </div>
                        <span>{{infoData.studentname}}</span>
                    </div>
                    <span>交卷时间：{{infoData.submittime}}</span>
                    <span>用时{{infoData.factexamtime}}秒</span>
                    <span>成绩2分</span> -->
                </div>
                <div class="correctValue">
                    <div class="allInfoData">
                        <div class="title">客观题 答题情况</div>
                        <div class="resBox">
                            <div class="item">
                                <p class="resOK">{{infoData.finalrightcount}}<span class="desc">道</span></p>
                                <p class="label">答对</p>
                            </div>
                            <div class="item">
                                <p class="resErr">{{infoData.finalfailcount}}<span class="desc">道</span></p>
                                <p class="label">答错</p>
                            </div>
                            <div class="item">
                                <p class="noRes">{{infoData.noanswer}}<span class="desc">道</span></p>
                                <p class="label">未答</p>
                            </div>
                            <div class="item">
                                <p class="resNum">{{fraction}}<span class="desc">分</span></p>
                                <p class="label">得分</p>
                            </div>
                        </div>
                    </div>
                    <div class="taskContent">
                        <el-collapse v-model="activeNames" @change="handleChange">
                            <el-collapse-item title="客观题" name="1">
                                <Objective :questionlist="objectiveData" ref="Objective" />
                            </el-collapse-item>
                           <el-collapse-item title="主观题" name="2" v-if="subjectiveData.length>0">
                                <Subjective :questionlist="subjectiveData" :type="type" ref="Subjective" />
                            </el-collapse-item>
                        </el-collapse>
                    </div>
                </div>
            </div>
        </el-scrollbar>
        <span slot="footer" class="dialog-footer">
            <el-button v-if="type" type="primary" @click="submit">确 定</el-button>
            <el-button  @click="visible = false">取消</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {getCourseExamDetails, readOverCourseExam} from '@/api/measApi/teachManagement.js'
import Objective from './correct/objective.vue'
import QsAndAns from './correct/qsAndAns.vue'
import Subjective from './correct/subjective.vue'
export default {
    
    data(){
        return {
            visible: false,
            title: '作业批阅',
            activeNames: ['1','2'],
            type: '',
            params: {
                code: '',
                infotype: ''
            },
            paramsSub: {
                code: '',
                infotype: '',
                reqdatalist: []
            },
            reqdatalistObj: {
                checkmemo: '',
                code: '',
                questioninfo: [],
                questiontype: '',
                userscore: ''
            },
            questioninfoObj: {
                checkmemo: '',
                code: '',
                userscore: ''
            },
            infoData: {},
            objectiveData: [],//客观题
            subjectiveData: [],//主观题
            fraction: 0
        }
    },
    components: {
        Objective,
        QsAndAns,
        Subjective
    },
    created(){
        console.log(this.params,'params')
    },
    methods: {
        init(code,infotype, type){
            this.visible = true
            this.fraction = 0
            this.type = type
            this.title = infotype == 1? '考试':'作业'
            this.params.code = code
            this.params.infotype = infotype
            this.paramsSub.code = code
            this.paramsSub.infotype = infotype
            this.getCourseExamDetails()
        },
        getCourseExamDetails(){
            getCourseExamDetails(this.params).then(res => {
                this.infoData = res.data
                this.handleQs(res.data.questionlist)
            })
        },
        // 分类题型
        handleQs(arrData){
            arrData.map(item => {
                if(item.questiontype === 1 || item.questiontype === 2 || item.questiontype === 3 || item.questiontype === 4 ||item.questiontype === 5){
                    if(item.questiontype === 2 || item.questiontype === 3 && item.uselanswer.length>0){
                            item.optioninfo.forEach(res => {
                                item.uselanswer.forEach(anres => {
                                    if(anres === res.optionsvalue){
                                        res.hasChoose = true
                                    }
                                })
                            })
                    }
                    this.objectiveData.push(item)
                }else if(item.questiontype === 6){
                    this.subjectiveData.push(item)
                }else if(item.questiontype === 7){
                    if(item.questionlist.length>0){
                        item.questionlist.map(itm => {
                            if(itm.questiontype === 6){
                                item.hasSubject = true
                            }else{
                                item.hasChoose = true
                                if(itm.questiontype === 2 && itm.uselanswer.length>0){
                                    itm.optioninfo.forEach(res => {
                                        itm.uselanswer.forEach(anres => {
                                            if(anres === res.optionsvalue){
                                                res.hasChoose = true
                                            }
                                        }) 
                                    })
                                }
                            }
                        })
                        this.objectiveData.push(item)
                        this.subjectiveData.push(item)
                    }
                }
            })
            this.handleFraction()
        },
        handleFraction(){
            this.objectiveData.forEach(item => {
                if(item.answerstatus == 1 ){
                    this.fraction = this.fraction+Number(item.quesscore)
                }
            })
        },
        handleClose(){
            this.visible = false
            this.objectiveData = []
            this.subjectiveData = []
        },
        handleChange(){

        },
        // 提交
        submit(){
            this.subjectiveData.forEach(item => {
                if(item.questiontype === 6){
                    let arr = JSON.parse(JSON.stringify(this.reqdatalistObj))
                    arr.checkmemo = item.checkmemo
                    arr.code = item.code
                    arr.questiontype = item.questiontype
                    arr.userscore = item.userscore
                    this.paramsSub.reqdatalist.push(arr)
                }
                if(item.questiontype === 7 && item.questionlist.length>0){
                    item.questionlist.forEach(res => {
                        if(res.questiontype === 6){
                            let arr = JSON.parse(JSON.stringify(this.questioninfoObj))
                            arr.checkmemo = res.checkmemo
                            arr.code = res.code
                            arr.userscore = res.userscore
                            this.reqdatalistObj.questioninfo.push(arr)
                            let reqArr = JSON.parse(JSON.stringify(this.reqdatalistObj))
                            reqArr.checkmemo = item.checkmemo
                            reqArr.code = item.code
                            reqArr.questiontype = item.questiontype
                            reqArr.userscore = item.userscore
                            this.paramsSub.reqdatalist.push(reqArr)
                        }
                    })
                }
            })
            this.readOverCourseExam()
        },
        readOverCourseExam(){
            readOverCourseExam(this.paramsSub).then(res => {
                if(res.code === '000'){
                    this.visible = false
                    this.$parent.getCourseExamList()
                }
            })
        }
    }
        
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body{
    background: #f6f6f6!important;
}
::v-deep .el-collapse-item__wrap{
    // background: #f6f6f6;
}
.correctConte{
    background: white;
.studentInfo{
    padding: 20px;
    align-items: center;
    .center,.right{
        font-size: 16px;
        line-height: 20px;
    }
    .left,.center{
        margin-right: 80px;
    }
    .left{
        .img{
            width: 120px;
            height: 120px;
            border-radius: 50%;
            background: #f6f6f6;
            img{
                width: 120px;
                height: 120px;
                border-radius: 50%;
            }
        }
        .name{
            font-size: 24px;
            margin-top: 26px;
        }
        .correctName{
            margin-top: 20px;
            font-size: 16px;
            line-height: 20px;
        }
    }
    .center{

    }
    .right{

    }
    // background: white;
    // align-items: center;
    // width: 100%;
    // >.left,>span{
    //     flex: 1;
    // }
    // .left{
    //     display: flex;
    //     // width: 100%;
    //     align-items: center;
    //     .img{
    //         width: 60px;
    //         height: 60px;
    //         border-radius: 50%;
    //         // background: red;
    //         margin: 0 10px;
    //             img{
    //                 width: 100%;
    //                 height: 100%;
    //                 border-radius: 50%;
    //             }
    //         }
    //     }
    }
    .correctValue{
        background: white;
        padding: 20px;
        margin-top: -6px;
        .allInfoData{
            background: #f6f6f6;
            padding: 20px;
            box-sizing: border-box;
            .title{
                font-size: 16px;
                font-weight: 700;
            }
            .resBox{
                display: flex;
                align-items: center;
                justify-content: space-between;
                .item{
                    text-align: center;
                    margin-top: 20px;
                    flex: 1;
                    .resOK,.resErr,.noRes,.resNum{
                        font-size: 36px;
                    }
                    .resOK{
                        color: #0cb760;
                    }
                    .resErr{
                        color: #d51b1b;
                    }
                    .desc{
                        font-size: 14px;
                    }
                    .label{
                        font-size: 14px;
                        margin-top: 20px;
                    }
                }
            }
        }
        .taskItem{

        }
    }
}

</style>